import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs/observable/of';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReviewEmployee/SetupKRA.html'
})

export class SetupKRAComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public showLoader = false;
    public EmployeeList:any = [];
    public PeriodList:any = [];
    public ReviewTemplateDetails:any = {PeriodId:null,EmployeeId:null};
    public reviewTemplateId: any = null;
    public employeeReviewId:any = null;
    public ReviewKRATemplates: any = [];
    public KRATotalWeightage: any = 0;
    public ReviewKPITemplates: any = [];
    public KPITotalWeightage: any = 0;
    public ReviewKPITemplateList: any = [];
    public ReviewKPITemplateKRA:any = {};
    active = true;
    public saveAsTemplate:any = false;
    public isLock:any = false;
    public DeleteKRAList :any=[];
    public DeleteKPIList :any=[];
    public CheckNewTemplate :any = false;
    deleteCountKRA:any  = 0;
    deleteCountKPI:any  = 0;
    public Templateshow:any;
    public isCopy:any; 
    public isExecuteEditable:any = false;
     public IsTemplateRequest:any = null;
    public ReviewTemplateList: any = [];
    public IsProceed :any = false;
    public IsShowTemp :any = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.IsTemplateRequest = JSON.parse(localStorage.getItem("IsTemplate"));
        if(this.IsTemplateRequest == "1"){
            this.reviewTemplateId = JSON.parse(localStorage.getItem("ReviewTemplateId"));
            this.IsShowTemp=true;
        }
        if(this.IsTemplateRequest == "2"){
            this.employeeReviewId = JSON.parse(localStorage.getItem("EmployeeReviewId"));
            this.IsShowTemp=false;
        }
    }

    ngOnInit() {
        this.getEmployeeList();
        this.getPeriodList();
        this.getReviewTemplateList();
        this.ReviewTemplateDetails.ReviewTemplateId = this.reviewTemplateId;
        if(this.IsTemplateRequest == "1"){
            if(this.reviewTemplateId == 0 ){
                this.reviewTemplateId=null
                this.CheckNewTemplate = true;
                this.ReviewTemplateDetails.CreatedBy = this.userDetail.SiteUserId;
                this.Templateshow=1;
               this.addKRAToList()
               this.addKRAToList()
               this.addKRAToList()
           
            }
          
        }
        if(this.IsTemplateRequest == "2"){
            this.getReviewEmployeeDetails();
            this.Templateshow=0; 
        }

            this.isCopy=false;
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
    }

    public getEmployeeList() {
        this.showLoader = true;
    
                this._httpService.ajaxPost("ReviewEmployeeList/GetSiteUser",{"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.EmployeeList = data["SiteUser"];
              
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    public getPeriodList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetPeriod', null).subscribe(
            data => {
                this.PeriodList = data["PeriodList"];
                this.PeriodList = this.PeriodList.filter( x => x.IsActive === true);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    public getReviewTemplateList() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/GetReviewTemplate',{"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewTemplateList = data["ReviewTemplateList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getReviewEmployeeDetails() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployee/GetReviewEmployeeDetails', {"EmployeeReviewId":this.employeeReviewId}).subscribe(
            data => {
                var ReviewEmployeeDetails = data["ReviewEmployee"][0];
                var ReviewKRAList = data["ReviewKRA"];
                var ReviewKPIList = data["ReviewKPI"];
                if(ReviewEmployeeDetails.StageId==2 && this.userDetail.RoleId ==3 )
                    this.isExecuteEditable =true;
                this.setupTemplateData(ReviewEmployeeDetails,ReviewKRAList,ReviewKPIList);
                this.setupKRAActions();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    setupTemplateData(ReviewEmployeeDetails,ReviewKRAList,ReviewKPIList){
        this.ReviewTemplateDetails.CommentObjective = ReviewEmployeeDetails.CommentObjective;
        this.ReviewTemplateDetails.CreatedBy = ReviewEmployeeDetails.CreatedBy;
        this.ReviewTemplateDetails.ReviewTemplateTitle= ReviewEmployeeDetails.ReviewTitle;
        this.ReviewTemplateDetails.EmployeeId = ReviewEmployeeDetails.EmployeeId;
        this.ReviewTemplateDetails.PeriodId = ReviewEmployeeDetails.PeriodId;
        this.ReviewTemplateDetails.ReviewTemplateId = 0;
        this.ReviewTemplateDetails.TemplateTitle = null;

        this.isLock = ReviewEmployeeDetails.IsLock;

        ReviewKRAList.forEach(element => {
            var KRATemplateItem = {
                IsEditKPI: element.IsEditKPI,
                KRADescription: element.KRADescription,
                KRATemplateId: element.KRAId,
                ReviewTemplateId: 0,
                Weightage: element.Weightage ,
                KRAMetric :element.KRAMetric
            }
            this.ReviewKRATemplates.push(KRATemplateItem);
        });

        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates));

        console.log("ReviewEmployeeKPIDetails");
        console.log(this.ReviewKPITemplates);
        ReviewKPIList.forEach(element => {
            var KPITemplateItem = {
                KPIDescription: element.KPIDescription,
                KPITemplateId: element.KPIId,
                KRATemplateId: element.KRAId,
                Weightage: element.Weightage,
                KPIMetric :element.KPIMetric
            }
            this.ReviewKPITemplates.push(KPITemplateItem);
        });

        this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates));
    }

    public getReviewTemplateDetails() {
        if(this.reviewTemplateId!= null && this.reviewTemplateId!= "null"){
            var tempId=this.ReviewTemplateDetails.EmployeeId;
            var PeriodId=this.ReviewTemplateDetails.PeriodId;
            var ReviewTemplateTitle = this.ReviewTemplateDetails.ReviewTemplateTitle;
            var tempId=this.ReviewTemplateDetails.EmployeeId;
             this.showLoader = true;
        this._httpService.ajaxPost('ReviewTemplate/GetReviewTemplate', {"TemplateId":this.reviewTemplateId,"UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this.ReviewTemplateDetails = data["ReviewTemplates"][0];
                this.ReviewTemplateDetails.EmployeeId = tempId;
                this.ReviewTemplateDetails.PeriodId = PeriodId;
                this.ReviewTemplateDetails.ReviewTemplateTitle = ReviewTemplateTitle;
                this.ReviewKRATemplates = data["ReviewKRATemplates"];
                this.ReviewKPITemplates = data["ReviewKPITemplates"];
                this.isCopy=true;
                this.setupKRAActions();
                this.employeeReviewId=0;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        }
    }

    public setupKRAActions(){
        this.KRATotalWeightage = 0;
        this.KPITotalWeightage = 0;
        var count = 1;
        this.ReviewKRATemplates.forEach(element => {
            var isKPI = false;
            var count1 = 1;
            this.ReviewKPITemplates.forEach(element1 => {
                if(element1.KRATemplateId == element.KRATemplateId){
                    isKPI = true;
                    element1.KRASequenceId = count;
                }
                element1.SequenceId = count1;
                count1 = count1+1;
            });
            element.IsEditKPI = isKPI;
            element.SequenceId = count;
            count = count+1;
            this.KRATotalWeightage = this.KRATotalWeightage + parseInt(element.Weightage);
        });


        if(this.IsTemplateRequest == "1"){
            this.ReviewTemplateDetails.ReviewTemplateId=0;
             this.ReviewTemplateDetails.CreatedBy = this.userDetail.SiteUserId;;
             if(this.isCopy==false)
             this.ReviewTemplateDetails.PeriodId = null;
  
   this.ReviewKRATemplates.forEach(element => {
      element.KRATemplateId =0;
      element.ReviewTemplateId =0;
         this.ReviewKPITemplates.forEach(element1 => {
           element1.KPITemplateId= 0;
           element1.KRATemplateId =0;

         });
      
     });
}



this.showKPIList()
        
    }

    
    showKPIList(){
       
        this.ReviewKRATemplates.forEach(item => {
            item.KPITotalWeightage = 0;
            item.ReviewKPITemplateList=JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m1 => m1.KRASequenceId == item.SequenceId)))
            this.ReviewKPITemplates.filter(m1 => m1.KRASequenceId == item.SequenceId).forEach(c => item.KPITotalWeightage += c.Weightage);
        });
       
         if(this.deleteCountKPI == 0){
         this.deleteCountKPI = this.ReviewKPITemplates.length;
         }
     }
 
 
    public addKRAToList(){
        var KRAListItem = {
            KRATemplateId : 0,
            KRADescription : "",
            Weightage : 0,
            ReviewTemplateId : this.ReviewTemplateDetails.ReviewTemplateId,
            SequenceId : this.deleteCountKRA + this.ReviewKRATemplates.length + 1 ,
            IsEditKPI : false  ,
            ReviewKPITemplateList:[], 
            KPITotalWeightage:0         
        };
        this.ReviewKRATemplates.push(KRAListItem);
        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates));
    }

    public deleteKRAFromList(item){
        //var TempDeleteReviewKPI =JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m => m.KRASequenceId == KRASequenceId)));

        this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m => m.KRASequenceId != item.SequenceId)));
        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates.filter(m => m.SequenceId != item.SequenceId)));
        this.deleteCountKRA = this.deleteCountKRA + 1;
        this.DeleteKRAList.push(item.KRATemplateId);
        this.calculateTotalKRAWeightage()
    }
   
    public calculateTotalKRAWeightage(){
        this.KRATotalWeightage = 0;
        this.ReviewKRATemplates.forEach(element => {
            this.KRATotalWeightage = this.KRATotalWeightage + parseInt(element.Weightage);
        });
    }

    public OnChangeGetTemplate(){
     
        
            if(this.CheckNewTemplate ){
        if(this.ReviewTemplateDetails.EmployeeId!="null" &&this.ReviewTemplateDetails.EmployeeId!=null && this.ReviewTemplateDetails.PeriodId!="null" && this.ReviewTemplateDetails.PeriodId!=null){
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployee/GetReviewEmployeeDetailsOnChange', {"EmployeeId":this.ReviewTemplateDetails.EmployeeId,"PeriodId":this.ReviewTemplateDetails.PeriodId}).subscribe(
            data => {
                
                this.IsProceed =true;
                var ReviewEmployeeDetails = data["ReviewEmployee"][0];
                var ReviewKRAList = data["ReviewKRA"];
                var ReviewKPIList = data["ReviewKPI"];
               
                this.IsTemplateRequest ="1";
                this.isLock = false;
                if(ReviewEmployeeDetails!= null || ReviewEmployeeDetails!= undefined)
               {

                this.ReviewKRATemplates = [];
                this.ReviewKPITemplates = [];
                this.ReviewTemplateDetails.CommentObjective = "";
                this.ReviewTemplateDetails.CreatedBy = this.userDetail.SiteUserId;
                this.ReviewTemplateDetails.ReviewTemplateId = 0;
                this.ReviewTemplateDetails.TemplateTitle = null;
                this.KRATotalWeightage = 0;
                this.KPITotalWeightage = 0;
                this.IsTemplateRequest = "2";   
                this.employeeReviewId =ReviewEmployeeDetails.EmployeeReviewId;
                this.setupTemplateData(ReviewEmployeeDetails,ReviewKRAList,ReviewKPIList);
                this.setupKRAActions();
               } 
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
            
        );

        this.showLoader = false;
        }
    }

    
}


    public addKPIToList(template){
        var KPIListItem = {
            KPITemplateId: 0,
            KPIDescription: "",
            Weightage: 0,
            KRASequenceId: template.SequenceId,
            KRATemplateId: template.KRATemplateId,
            SequenceId: this.deleteCountKPI + template.ReviewKPITemplateList.length + 1
            
        };
        template.ReviewKPITemplateList.push(KPIListItem);
        template.ReviewKPITemplateList=JSON.parse(JSON.stringify(template.ReviewKPITemplateList));
        
    }


  
    public deleteKPIFromList(item){
        
        var tempTEmplate =this.ReviewKRATemplates.filter(m => m.SequenceId == item.KRASequenceId)[0].ReviewKPITemplateList;
       this.ReviewKRATemplates.filter(m => m.SequenceId == item.KRASequenceId)[0].ReviewKPITemplateList= JSON.parse(JSON.stringify(tempTEmplate.filter(m1 => m1.SequenceId != item.SequenceId)));
       // this.ReviewKPITemplateList = JSON.parse(JSON.stringify(this.ReviewKPITemplateList.filter(m => m.SequenceId != item.SequenceId)));
        this.deleteCountKPI = this.deleteCountKPI + 1;
        this.DeleteKPIList.push(item.KPITemplateId);
        this.calculateTotalKPIWeightage(item)
    }

    public calculateTotalKPIWeightage(template){
        var tempTemplate =this.ReviewKRATemplates;
       
 if(template != null){
             tempTemplate =this.ReviewKRATemplates.filter(m => m.SequenceId == template.KRASequenceId)[0];
             tempTemplate.KPITotalWeightage = 0;
             tempTemplate.ReviewKPITemplateList.forEach(element => {
            tempTemplate.KPITotalWeightage = tempTemplate.KPITotalWeightage + parseInt(element.Weightage);
                 });
            }
}

public addUpdateReviewEmployeeKPI(){

    var check =1;
    if(this.ReviewKRATemplates.filter(m => (m.KPITotalWeightage != 100 && m.ReviewKPITemplateList.length>0)).length==0){
        // this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates.filter(m =>
        //  m.KRATemplateId != this.ReviewKPITemplateKRA.KRATemplateId)));
        this.ReviewKPITemplates=[];
    
        this.ReviewKRATemplates.forEach(element => {
            element.ReviewKPITemplateList.forEach(item => {
            this.ReviewKPITemplates.push(item);
           });
           if(element.ReviewKPITemplateList.length!=0)
           element.IsEditKPI = true;
        });
        this.ReviewKRATemplates = JSON.parse(JSON.stringify(this.ReviewKRATemplates))
        this.ReviewKPITemplates = JSON.parse(JSON.stringify(this.ReviewKPITemplates));
        check=0;
}
else{
    this._sharedService.ShowMessage("error|" + "Total KPI weightage should be 100");
}
if(check==0){
    this.addUpdateReviewTemplate()
}



}



validateReviewKPIDetails(){
    var mandatory = "";
    var invalid = "";
    var functional = "";

    if(this.ReviewKPITemplates.length != 0)
    {
       
        this.ReviewKPITemplates.forEach(element => {
            if(element.KPIDescription == "" || element.KPIDescription == null)
            {
                mandatory = mandatory + "<br>KPI Description";
            }
            if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
            {
                mandatory = mandatory + "<br>Weightage";
            }
            if( isNaN(element.Weightage))
                {
                    mandatory = mandatory + "<br>KPI Weightage should be number";
                }
        });
    }
    
    if (mandatory == "" && invalid == "" && functional == "") {
        return true;
    } else {
        var msg = "";
        if (mandatory != "") {
            msg = msg + "Please enter : " + mandatory;
            msg = msg + "<br>";
        }
        if (invalid != "") {
            msg = msg + "Please enter valid : " + invalid;
            msg = msg + "<br>";
        }
        if (functional != "") {
            msg = msg + functional;
        }
        this._sharedService.ShowMessage("error|" + msg);
    }
    return false;

}

    public addUpdateReviewEmployee(){
        
        console.log("ReviewEmployeeDetails");
        console.log(this.ReviewTemplateDetails);
        // CommentObjective: "New Objectives"
        // CreatedBy: 1
        // EmployeeId: "153"
        // PeriodId: 1
        // ReviewTemplateId: 1
        // TemplateTitle: "FY12019"
        var ReviewEmployeeDetails = {
            EmployeeReviewId : 0,
            EmployeeId : null,
            ReviewerId : null,
            PeriodId : this.ReviewTemplateDetails.PeriodId,
            CommentObjective : this.ReviewTemplateDetails.CommentObjective,
            CreatedBy : this.ReviewTemplateDetails.CreatedBy,
            IsLock : this.isLock,
            StageId : null,
            ReviewTitle:null
        }

        if(this.IsTemplateRequest == "2"){
            ReviewEmployeeDetails.EmployeeReviewId = this.employeeReviewId;
        }

        ReviewEmployeeDetails.EmployeeId = parseInt(this.ReviewTemplateDetails.EmployeeId);
        ReviewEmployeeDetails.ReviewTitle=this.ReviewTemplateDetails.ReviewTemplateTitle;
        ReviewEmployeeDetails.ReviewerId = this.EmployeeList.filter(m => m.SiteUser_Id == ReviewEmployeeDetails.EmployeeId)[0].Reviewed_By;
        if(ReviewEmployeeDetails.IsLock == true){
            ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Locked;
        }
        else{
            ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Setup;
        }
        console.log("ReviewEmployeeKRADetails");
        console.log(this.ReviewKRATemplates);
        // IsEditKPI: true
        // KRADescription: "Sales of 50000 aed"
        // KRATemplateId: 1
        // ReviewTemplateId: 1
        // SequenceId: 1
        // Weightage: 50
        var ReviewKRADetails = [];
        this.ReviewKRATemplates.forEach(element => {
            var KRAItem;
            if(this.isCopy== true){
             KRAItem = {
                KRAId : 0,
                KRADescription : element.KRADescription,
                Weightage : element.Weightage,
                EmployeeReviewId : null,
                IsEditKPI : element.IsEditKPI,
                SequenceId : element.SequenceId,
                KRAMetric : element.KRAMetric
            };
        }

        else{
            KRAItem = {
               KRAId : element.KRATemplateId,
               KRADescription : element.KRADescription,
               Weightage : element.Weightage,
               EmployeeReviewId : null,
               IsEditKPI : element.IsEditKPI,
               SequenceId : element.SequenceId,
               KRAMetric : element.KRAMetric
           };
       }
            if(this.IsTemplateRequest == "2"){
                KRAItem.EmployeeReviewId = this.employeeReviewId;
            }
            ReviewKRADetails.push(KRAItem);
        });

        console.log("ReviewEmployeeKPIDetails");
        console.log(this.ReviewKPITemplates);
        // KPIDescription: "sales with 5% profit"
        // KPITemplateId: 3
        // KRASequenceId: 1
        // KRATemplateId: 1
        // SequenceId: 1
        // Weightage: 50
        var ReviewKPIDetails = [];
        this.ReviewKPITemplates.forEach(element => {
            var KPIItem;
            if(this.isCopy== true){
                 KPIItem = {
                    KPIId : 0,
                    KPIDescription : element.KPIDescription,
                    Weightage : element.Weightage,
                    KRAId : 0,
                    KRASequenceId : element.KRASequenceId,
                    SequenceId : element.SequenceId,
                    KPIMetric : element.KPIMetric
                };
            }
            else{
                 KPIItem = {
                    KPIId : element.KPITemplateId,
                    KPIDescription : element.KPIDescription,
                    Weightage : element.Weightage,
                    KRAId : element.KRATemplateId,
                    KRASequenceId : element.KRASequenceId,
                    SequenceId : element.SequenceId,
                    KPIMetric : element.KPIMetric
                };
            }
          
            ReviewKPIDetails.push(KPIItem);
        });

       // var deleteKRA ="";
       // var deleteKPI="";
        if(this.DeleteKRAList.length>0)
         {var deleteKRA =this.DeleteKRAList.toString();
            deleteKRA=deleteKRA+",";
        }
        if(this.DeleteKPIList.length>0)
        {
            var deleteKPI =this.DeleteKPIList.toString();
         deleteKPI=deleteKPI+",";
       }
       
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployeeList/AddUpdateReviewEmployeeDetails', 
        {"ReviewEmployeeDetails":ReviewEmployeeDetails,
        "ReviewKRADetails":ReviewKRADetails,
        "ReviewKPIDetails":ReviewKPIDetails,
        "deleteKRA":deleteKRA,
        "deleteKPI":deleteKPI,
        "UserId":this.userDetail.SiteUserId}).subscribe(
            data => {
                this._sharedService.ShowMessage("success|Data Updated Successfully");
                this._route.navigateByUrl("/reviewEmployeeList");
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        
    }

    setName(){
        this.ReviewTemplateDetails.TemplateTitle=this.ReviewTemplateDetails.ReviewTemplateTitle;
    }
    validateReviewDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";

        if (this.ReviewTemplateDetails.EmployeeId == null || this.ReviewTemplateDetails.EmployeeId == "null") {
            mandatory = mandatory + "<br>Employee";
        }
        if (this.ReviewTemplateDetails.ReviewTemplateTitle == null || this.ReviewTemplateDetails.ReviewTemplateTitle == "") {
            mandatory = mandatory + "<br>Title";
        }

        if (this.ReviewTemplateDetails.PeriodId == null || this.ReviewTemplateDetails.PeriodId == "null") {
            mandatory = mandatory + "<br>Period";
        }

        if (this.ReviewTemplateDetails.CommentObjective == null || this.ReviewTemplateDetails.CommentObjective == "") {
            mandatory = mandatory + "<br>Objective Comment";
        }

        if(this.ReviewKRATemplates.length == 0)
        {
            mandatory = mandatory + "<br>KRA List";
        }
        else{
            this.ReviewKRATemplates.forEach(element => {
                if(element.KRADescription == "" || element.KRADescription == null)
                {
                    mandatory = mandatory + "<br>KRA Description";
                }
                if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
                {
                    mandatory = mandatory + "<br>Weightage";
                }
                if( isNaN(element.Weightage))
                {
                    mandatory = mandatory + "<br>KRA Weightage should be number";
                }
            });
        }
       
        //KPI list validated while adding KPI under KRA

        if(this.saveAsTemplate){
            if (this.ReviewTemplateDetails.TemplateTitle == null || this.ReviewTemplateDetails.TemplateTitle == "") {
                mandatory = mandatory + "<br>Template Title";
            }
        }

        if(this.KRATotalWeightage != 100)
        {
            mandatory = mandatory + "<br>Total KRA weightage should be 100";
        }
        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;
    }


   





    public addUpdateReviewTemplate() { 
      
//         this._httpService.ajaxPost('ReviewEmployee/GetReviewEmployeeDetailsOnChange', {"EmployeeId":this.ReviewTemplateDetails.EmployeeId,"PeriodId":this.ReviewTemplateDetails.PeriodId}).subscribe(
//             data => {
//                 
//                var proceed = false
               
//                 var ReviewEmployeeDetails = data["ReviewEmployee"];
//                 var ReviewKRAList = data["ReviewKRA"];
//                 var ReviewKPIList = data["ReviewKPI"];
//                 var ReviewEmployeeDetailstest = data["ReviewEmployee"][0];
//                  if(this.employeeReviewId== null)
//                     this.employeeReviewId=0
              
//                  if(this.employeeReviewId!=0)
//                {
//                 if(this.employeeReviewId== ReviewEmployeeDetailstest.EmployeeReviewId){
                  
                  
//                     proceed=true; 
                    
//                  }
//                 }
//                if((ReviewEmployeeDetails.length==0 && this.employeeReviewId==0)||(proceed==true && ReviewEmployeeDetails.length!=0 ))
// {
        if(this.validateReviewDetails()){
            if(this.saveAsTemplate){
                
                var objReviewTemplateDetails = {
                    ReviewTemplateId: this.ReviewTemplateDetails.ReviewTemplateId,
                    TemplateTitle: this.ReviewTemplateDetails.TemplateTitle,
                    PeriodId: this.ReviewTemplateDetails.PeriodId,
                    CommentObjective: this.ReviewTemplateDetails.CommentObjective,
                    CreatedBy: this.ReviewTemplateDetails.CreatedBy
                };
                var objReviewTemplateKRADetails = [];
                this.ReviewKRATemplates.forEach(element => {
                    var KRAItem = {
                        KRATemplateId : 0,
                        KRADescription : element.KRADescription,
                        Weightage : element.Weightage,
                        EmployeeReviewId : 0,
                        IsEditKPI : element.IsEditKPI,
                        SequenceId : element.SequenceId,
                        KRAMetric : element.KRAMetric
                    };
                    if(this.IsTemplateRequest == "2"){
                        KRAItem.EmployeeReviewId = this.employeeReviewId;
                    }
                    objReviewTemplateKRADetails.push(KRAItem);
                });
        
               
                
                var objReviewTemplateKPIDetails = [];
                this.ReviewKPITemplates.forEach(element => {
                    var KPIItem = {
                        KPITemplateId : 0,
                        KPIDescription : element.KPIDescription,
                        Weightage : element.Weightage,
                        KRATemplateId :0,
                        KRASequenceId : element.KRASequenceId,
                        SequenceId : element.SequenceId,
                        KPIMetric : element.KPIMetric
                    };
                    objReviewTemplateKPIDetails.push(KPIItem);
                });
        
                this.showLoader = true;
                this._httpService.ajaxPost('ReviewTemplate/AddUpdateReviewTemplate', {"ReviewTemplateDetails":objReviewTemplateDetails,
                "ReviewTemplateKRADetails":objReviewTemplateKRADetails,"ReviewTemplateKPIDetails":objReviewTemplateKPIDetails,"UserId":this.userDetail.SiteUserId}).subscribe(
                    data => {
                        this.addUpdateReviewEmployee();
                        //this._sharedService.ShowMessage("success|Data Updated Successfully");
                       // this._route.navigateByUrl("/reviewEmployeeList");
                    },
                    err => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                    }
                );
            }
            else{
                this.addUpdateReviewEmployee();
            }
        }

    }
    // else{
    //     this._sharedService.ShowMessage("warning|Review Already exists for the User on the period");
    //     this.showLoader = false;
    // }
    // },
    // err => {
    //                 this.showLoader = false;
    //               this._sharedService.ShowMessage(this.constants.globalError);
    //            },
    //            () => {
    //               this.showLoader = false;
    //            }
                
    //       );
        
    //       this.showLoader = false;
    //         }
    

//     public OnChangeGetTemplatetest(){
     
       
//            this.IsProceed =true;
//               },
//       
// }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewEmployee/SetupKRA.component.ts
 **/